import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { ValidateFieldService } from '@shared/services/validateField.service';
@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.sass'],
})
export class InputTextComponent {
  @Input() align: string;
  @Input() label: string;
  @Input() value: number | string;
  @Input() formGroup: FormGroup;
  @Input() formControlName: string;
  @Input() mask: string;
  @Input() suffix: string;
  @Input() thousandSeparator: string;

  constructor(public validate: ValidateFieldService) { }

  get formControl(): AbstractControl {
    return this.formGroup?.controls[this.formControlName];
  }
}
